import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { ClientSidePaginationList } from '../../hoc/ClientSidePaginationList.jsx';
import { ARRANGEMENT_TYPE_SLUG, DEPARTMENTS } from '../../../config';
import { setLastBreadcrumbsArray, setPageHeadObject } from '../../actions/app';

import FilterSet from '../common/Filters/FilterSet.jsx';
import Sorting from '../common/Filters/Sorting.jsx';

import { deleteOffer, getOffersList, uploadOfferImage } from '../../actions/shop';
import { getVisibleShopOffers } from '../../reducers/shop-selector';
import OffersItem from './OffersItem.jsx';


const Offers = ({ isLoading, setPageHeadObject, setLastBreadcrumbsArray,
                  count, paginateList, uploadOfferImage, deleteOffer }) => {
  let { type } = useParams();

  useEffect(() => {
    const title = DEPARTMENTS['content']['children'][type]['title'];
    setPageHeadObject({ title, create: true });
    setLastBreadcrumbsArray({ title, url: `/${type}/`, create: true });
  }, []);

  let items = [];
  if (!isLoading) {
    if (count){
      items = paginateList.map(item => <OffersItem key={ item.id } {...item}
                                                         type={ type }
                                                         onChangeImage={ uploadOfferImage }
                                                         is_moderator={ false }
                                                         onDelete={ deleteOffer }/>);
    } else {
      items = <p>{ gettext('Ничего не найдено.') }</p>;
    }
  }
  return <div>
    <FilterSet isLoading={ isLoading }
               statusFilter={ true }
               difficultyFilter={ true }
               tonalityFilter={ type === ARRANGEMENT_TYPE_SLUG }
               colSize={ type === ARRANGEMENT_TYPE_SLUG ? 4 : 6 }/>
    { count > 0 && <Sorting fields={ ['id', 'title', 'price'] }/> }
    { items }
  </div>
}

Offers.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  setPageHeadObject: PropTypes.func.isRequired,
  setLastBreadcrumbsArray: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  paginateList: PropTypes.array.isRequired,
  is_moderator: PropTypes.bool.isRequired,
  uploadOfferImage: PropTypes.func.isRequired,
  deleteOffer: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    list: getVisibleShopOffers(state),
  }
};

export default compose(
  connect(mapStateToProps, { loadListFromServer: getOffersList, deleteOffer, uploadOfferImage,
    setPageHeadObject, setLastBreadcrumbsArray }),
  LoginRequired,
  Page,
  ClientSidePaginationList
)(Offers);

